import React from 'react';
import type { C3Rank } from '../../mock/c3';
import Dialog from '../../ui/Dialog';

interface AgentRankModalProps {
  ranks: C3Rank[];
  onToggle: (index: number) => void;
  onClose: () => void;
}

const AgentRankModal: React.FC<AgentRankModalProps> = ({ ranks, onToggle, onClose }) => {
  return (
    <Dialog title="Agent Rank — Graduated Autonomy" onClose={onClose}>
      <div className="text-c3-mute text-sm mb-[18px]">
        Toggle which remediation classes run automatically vs require human approval.
      </div>
      <div className="space-y-2">
        {ranks.map((r, i) => (
          <div
            key={r.name}
            className="grid grid-cols-1 md:grid-cols-[1fr_190px_120px] gap-3.5 items-center bg-c3-tile border border-c3-tile-bd rounded-lg px-4 py-3"
          >
            <div>
              <div className="font-bold text-sm">{r.name}</div>
              <div className="text-c3-mute text-[13px] mt-0.5">{r.desc}</div>
            </div>
            <div
              className={`text-xs font-bold ${
                r.risk === 'low' ? 'text-c3-green' : r.risk === 'med' ? 'text-c3-amber' : 'text-c3-red'
              }`}
            >
              BLAST RADIUS: {r.risk.toUpperCase()}
            </div>
            <button
              type="button"
              onClick={() => onToggle(i)}
              className={`relative w-[104px] h-[30px] rounded-2xl border-2 border-c3-tile-bd bg-c3-bg cursor-pointer justify-self-end ${r.mode}`}
            >
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] font-bold text-c3-mute">GATED</span>
              <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[12px] font-bold text-c3-mute">AUTO</span>
              <span
                className={`absolute top-0.5 w-12 h-[22px] rounded-full flex items-center justify-center text-[12px] font-bold text-on-fill transition-all ${
                  r.mode === 'auto' ? 'left-[52px] bg-c3-green' : 'left-0.5 bg-c3-amber'
                }`}
              >
                {r.mode === 'auto' ? 'AUTO' : 'GATED'}
              </span>
            </button>
          </div>
        ))}
      </div>
    </Dialog>
  );
};

export default AgentRankModal;
